import { Helmet } from "react-helmet";
import Footer from "../../components/Footer";
import Loader from "../../components/Loader";
import Prospectlist from "./prospectlist";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import React, { useEffect, useState } from "react";
import ProspectListView from "./prospect-list-view/ProspectListView";
import { useLocation } from "react-router-dom";

const ProspectMain = ({ history, match }) => {
  const [isGridView, setIsGridView] = useState(false);
  const [hasGridRendered, setHasGridRendered] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");

  useEffect(() => {
    if (type === "notes") {
      setIsGridView(true);
      setHasGridRendered(true);
    }
  }, [type]);
  const handleView = (view) => {
    if (view === "grid") {
      setIsGridView(true);
      setHasGridRendered(true);
    } else {
      setIsGridView(false);
    }
  };
  return (<React.Fragment>
    <Helmet title="Prospects" />

    {/* Grid View */}
    <div style={{ display: isGridView ? "none" : "block" }}>
      <Prospectlist history={history} match={match} handleView={handleView} />
    </div>

    {/* list View */}
    {hasGridRendered && (
      <div style={{ display: isGridView ? "block" : "none" }}>
        <ProspectListView
          history={history}
          match={match}
          handleView={handleView}
          type={type}
        />
      </div>
    )}

    <Footer />
  </React.Fragment>);
}

export default withAuthenticationRequired(ProspectMain, {
  onRedirecting: () => <Loader />,
});